/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCustomer200Response
 */
export interface GetCustomer200Response {
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200Response
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200Response
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200Response
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200Response
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200Response
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200Response
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200Response
     */
    phoneNumberCode?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetCustomer200Response
     */
    creationTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200Response
     */
    internalNote?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomer200Response
     */
    marketingCommunication?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetCustomer200Response
     */
    birthDate?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomer200Response
     */
    tags?: Array<string>;
}

/**
 * Check if a given object implements the GetCustomer200Response interface.
 */
export function instanceOfGetCustomer200Response(value: object): value is GetCustomer200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetCustomer200ResponseFromJSON(json: any): GetCustomer200Response {
    return GetCustomer200ResponseFromJSONTyped(json, false);
}

export function GetCustomer200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomer200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'source': json['source'] == null ? undefined : json['source'],
        'phoneNumberCode': json['phoneNumberCode'] == null ? undefined : json['phoneNumberCode'],
        'creationTime': json['creationTime'] == null ? undefined : (new Date(json['creationTime'])),
        'internalNote': json['internalNote'] == null ? undefined : json['internalNote'],
        'marketingCommunication': json['marketingCommunication'] == null ? undefined : json['marketingCommunication'],
        'birthDate': json['birthDate'] == null ? undefined : (new Date(json['birthDate'])),
        'tags': json['tags'] == null ? undefined : json['tags'],
    };
}

export function GetCustomer200ResponseToJSON(json: any): GetCustomer200Response {
    return GetCustomer200ResponseToJSONTyped(json, false);
}

export function GetCustomer200ResponseToJSONTyped(value?: GetCustomer200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'surname': value['surname'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'source': value['source'],
        'phoneNumberCode': value['phoneNumberCode'],
        'creationTime': value['creationTime'] == null ? undefined : ((value['creationTime']).toISOString()),
        'internalNote': value['internalNote'],
        'marketingCommunication': value['marketingCommunication'],
        'birthDate': value['birthDate'] == null ? undefined : ((value['birthDate']).toISOString()),
        'tags': value['tags'],
    };
}

